// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Services
import AuthForgotPasswordService from '@/app/services/auth/auth-forgot-password/auth-forgot-password-service.js';
import userService from "@/app/services/main/user/user-service.js"

// Constants
import { GA } from '@/app/constants/ga-constants';
import { STATUS_CODES } from '@/app/constants/status-constants';

// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
	name: 'AuthForgotPassword',
	mixins: [
		GoogleAnalyticsMixins,
		toastMessageMixins
	],
	data() {
		return {
			email: '',
			isAPILoading: false
		}
	},
	computed: {
		validationRules() {
			let formData = {
				email: {}
			}

			formData = vuelidateUtil.setRequiredValidation(formData, 'email');
			formData = vuelidateUtil.setEmailValidation(formData, 'email');

			return formData;
		}
	},
	methods: {
		onSubmit() {
			if(this.$v.invalid) {
				return;
			}

			this.isAPILoading = true;
			let userDetails = {
				email: this.email
			}
			
			userService.postAuthForgotPass(userDetails)
				.then(res => {
					this.isAPILoading = false;
					if (res.status === STATUS_CODES.SUCCESS) {
						// Send Analytics
						this.sendEventTrackingToGA(GA.PASSWORD_PAGE.FORGOT_PASSWORD_VERIFY_BUTTON.ACTION, GA.PASSWORD_PAGE.CATEGORY, GA.PASSWORD_PAGE.FORGOT_PASSWORD_VERIFY_BUTTON.LABEL);

						this.$swal({
							imageHeight: '30px',
							imageUrl: `${require('@/assets/images/_shared/success-dog.png')}`,
							imageAlt: 'Success Dog',
							title: 'Awesome!',
							text: 'Please check your email for verification.',
							confirmButtonColor: '#4B8BFF',
							confirmButtonText: 'Got it'
						}).then(() => {
							this.$router.push('/login');
						});
					} else if (res.status === STATUS_CODES.BAD_REQUEST ||
						res.status === STATUS_CODES.NOT_FOUND
					) {
						// Send Analytics
						this.sendEventTrackingToGA(GA.PASSWORD_PAGE.FORGOT_PASSWORD_VERIFY_BUTTON.ACTION, GA.PASSWORD_PAGE.CATEGORY, GA.PASSWORD_PAGE.FORGOT_PASSWORD_VERIFY_BUTTON.LABEL);

						this.$swal({
							imageHeight: '30px',
							imageUrl: `${require('@/assets/images/_shared/sad-dog.png')}`,
							imageAlt: 'Sad Dog',
							title: '',
							text: `Your email doesn't exist.`,
							confirmButtonColor: '#4B8BFF',
							confirmButtonText: 'Please sign up here'
						}).then((result) => {
							if(result.value)
								this.$router.push('/register');
						});
					}
				})
		}
	},
	validations() {
		return this.validationRules;
	}
}
